<script setup>
import {onMounted, ref} from "vue";

const categories = ref([]);
const loadingCategories = ref(true);
const model = defineModel();

defineProps({
    errors: Array,
    training: Object
})

onMounted(() => {
    loadingCategories.value = true;
    axios.get('/training-categories')
        .then(response => {
            categories.value = response.data.data;
        }).catch(() => {
        }).finally(() => {
            loadingCategories.value = false;
        });
})
</script>

<template>
    <b-field :label="$t('trainings.fields.category.name')" horizontal custom-class="mb-3"
             :type="errors ? 'is-danger' : null"
             :message="errors ? errors[0] : null">
        <b-select
            :placeholder="$t('trainings.fields.category.placeholder')"
            expanded
            v-model="model"
            id="training_category_id"
            :loading="loadingCategories">
            <option value="" v-bind:hidden="!model">{{ $t('trainings.fields.category.placeholder') }}</option>
            <option
                v-for="category in categories"
                v-bind:value="category.id"
                :key="category.id">
                {{ category.name }}
            </option>
        </b-select>
    </b-field>
</template>
